import { Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export const AXES = ["process", "aiRecommendation"];

const AXIS_STYLES = {
    process:          { bg: "#EEF0FB", color: "#4A52A3" },
    aiRecommendation: { bg: "#F3EDFB", color: "#6B3FA0" },
    humanDecision:    { bg: "#E3F1F4", color: "#1B6B7A" },
};

// Outcome colour overrides the axis colour.
const VALUE_STYLES = {
    positive: { bg: "#DDF3E4", color: "#1F7A3F" },
    conditional: { bg: "#FFF1D6", color: "#9A6200" },
    negative: { bg: "#FBE0E0", color: "#B3261E" },
};

const CandidateAxisPill = ({ axis, value, onClick }) => {
    const { t } = useTranslation("models");
    if (!value) return null;
    const key = value.toLowerCase();
    const style = (axis === "aiRecommendation" && VALUE_STYLES[key]) || AXIS_STYLES[axis];
    return (
        <Text
            as={onClick ? "button" : "span"}
            onClick={onClick}
            cursor={onClick ? "pointer" : undefined}
            _hover={onClick ? { opacity: 0.8 } : undefined}
            display="inline-block"
            bg={style.bg}
            color={style.color}
            fontSize="11px"
            fontWeight={600}
            lineHeight={1.3}
            px={2.5}
            py={0.5}
            borderRadius="12px"
            title={t(`candidateAxes.title.${axis}`)}
        >
            {t(`candidateAxes.${axis}.${key}`)}
        </Text>
    );
};

export default CandidateAxisPill;
